import { createFileRoute } from "@tanstack/react-router";
import { buildRouteHead } from "@/lib/seo/routeHead";
import Pricing from "@/pages/Pricing";

export const Route = createFileRoute("/prezzi")({
  head: () => buildRouteHead({ pathname: "/prezzi" }),
  component: Pricing,
});
